module.exports = __webpack_public_path__ + "img/nccc-bio-logo.68e23a59.jpg";